import { generatorMediaURL } from "../../../helpers/index";
import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import styles from "./AccountHeader.module.scss";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useDispatch } from "react-redux";
import { media9codeOrCms } from "../../../utils/common";

interface IProps {
  profile: any;
}

const AccountHeader = (props: IProps) => {
  const { profile } = props;
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // localStorage.removeItem('qc_sid')
    // localStorage.removeItem('qc_email')
    // localStorage.removeItem('qc_uid')
    localStorage.removeItem('sid')
    window.open("/login", "_self")
  };
  
  return (
    <>
      <div className={styles.Wrapper} onClick={handleClick}>
        <Avatar src={media9codeOrCms(profile?.photo)} />
        {/* <p className={styles.Name}>{(profile?.lastName || '') + ' ' + (profile?.firstName || '')}</p> */}
        <p className={styles.Name}>{(profile?.email || '') + ' ' + (profile?.firstName || '')}</p>
      </div>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        className={styles.PopoverWrapper}
      >
        <Box className={styles.PopoverBox}>
          <div className={styles.PopoverInfo}>
            <div className={styles.Avatar}>
              {profile?.photo && (
                <img src={media9codeOrCms(profile?.photo)} alt="avt" />
              )}
            </div>
            <div className={styles.InfoDetail}>
              <div>
                <Typography variant={"h3"}>
                  {`${(profile?.lastName || '') + ' ' + (profile?.firstName || '') || "---"}`}
                </Typography>
                <p>{profile?.email}</p>
              </div>
              <span onClick={() => window.open(`${process.env.REACT_APP_MY_ACCOUNT_WEBAPP}`, '_blank', 'noopener,noreferrer')} style={{ textDecoration: "none" }}>
                <Button variant="contained" color="primary">
                  Xem hồ sơ
                </Button>
              </span>
            </div>
          </div>

          <div className={styles.PopoverLogout} onClick={handleLogout}>
            <Typography variant={"h5"}>Đăng xuất</Typography>
            <ExitToAppIcon color="disabled" />
          </div>
        </Box>
      </Popover>
    </>
  );
};

export default AccountHeader;
